export default __webpack_public_path__ + "static/media/globatech-logo.30db9d0c.png";